import React, { useContext, useEffect } from "react";

import DestinationItem from "./DestinationItem";
import DestinationContext from "../../context/destination/destinationContext";

import Grid from '@mui/material/Grid2';

const Destinations = () => {
  const destinationContext = useContext(DestinationContext);

  const { destinations, getDestinations, loading } = destinationContext;

  useEffect(() => {
    getDestinations();
    //eslint-disable-next-line
  }, []);


  if (destinations !== null && destinations.length === 0 && !loading) {
    return <h4>No destinations to show</h4>;
  }

  return (
    <Grid container spacing={{ xs: 2, sm: 4 }}>
      {destinations !== null && !loading ? (
        destinations.map((destination) =>
            <Grid key={destination.id} size={{ xs: 6, sm: 'auto' }}>
              <DestinationItem destination={destination} />
            </Grid>
      )
      ) : (
        <div className="preloader-wrapper big active">
          <div className="spinner-layer spinner-blue-only">
            <div className="circle-clipper left">
              <div className="circle"></div>
            </div>
            <div className="gap-patch">
              <div className="circle"></div>
            </div>
            <div className="circle-clipper right">
              <div className="circle"></div>
            </div>
          </div>
        </div>
      )}
    </Grid>
  );
};

export default Destinations;
